// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.templates-page {
  width: min(1180px, calc(100% - 48px));
  margin: 0 auto;
  padding: 32px 0 64px;
  box-sizing: border-box;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
}

.templates-search {
  width: min(360px, 100%);
  height: 46px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 14px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  color: var(--color-text-secondary);
}

.templates-search-row {
  margin-top: 18px;
}

.templates-search:focus-within {
  border-color: var(--color-text-secondary);
}

.templates-search input {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--color-text-primary);
  font: inherit;
  font-size: 14px;
}

.templates-search input::placeholder {
  color: var(--color-text-secondary);
}

.templates-card {
  appearance: none;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

.templates-card:hover {
  background: var(--color-bg-user-bubble);
  border-color: var(--color-text-secondary);
  transform: translateY(-1px);
}

.templates-library__toolbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 16px;
}

.templates-library__title {
  margin: 0;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 28px;
  font-weight: 400;
  line-height: 1.15;
}

.templates-library__count {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--color-text-secondary);
}

.templates-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-bottom: 18px;
  border-bottom: 1px solid var(--color-border-input);
}

.templates-tab {
  height: 32px;
  padding: 0 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 999px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.templates-tab:hover {
  color: var(--color-text-primary);
}

.templates-tab--active {
  background: var(--color-text-primary);
  border-color: var(--color-text-primary);
  color: var(--color-bg-root);
}

.templates-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
  margin-top: 28px;
}

.templates-card {
  min-width: 0;
  border-radius: 6px;
  overflow: hidden;
}

.templates-card__preview {
  position: relative;
  display: block;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background:
    linear-gradient(135deg, color-mix(in srgb, var(--color-accent-base) 20%, transparent), transparent 60%),
    var(--color-bg-input);
  border-bottom: 1px solid var(--color-border-input);
}

.templates-card--blue .templates-card__preview {
  background:
    linear-gradient(135deg, rgba(111, 158, 232, 0.24), transparent 60%),
    var(--color-bg-input);
}

.templates-card--green .templates-card__preview {
  background:
    linear-gradient(135deg, rgba(95, 191, 146, 0.22), transparent 60%),
    var(--color-bg-input);
}

.templates-card--teal .templates-card__preview {
  background:
    linear-gradient(135deg, rgba(69, 184, 196, 0.2), transparent 60%),
    var(--color-bg-input);
}

.templates-card--yellow .templates-card__preview {
  background:
    linear-gradient(135deg, rgba(214, 168, 79, 0.22), transparent 60%),
    var(--color-bg-input);
}

.templates-card--red .templates-card__preview {
  background:
    linear-gradient(135deg, rgba(228, 117, 117, 0.2), transparent 60%),
    var(--color-bg-input);
}

.templates-card--pink .templates-card__preview {
  background:
    linear-gradient(135deg, rgba(222, 127, 166, 0.2), transparent 60%),
    var(--color-bg-input);
}

.templates-card--cyan .templates-card__preview {
  background:
    linear-gradient(135deg, rgba(86, 182, 222, 0.2), transparent 60%),
    var(--color-bg-input);
}

.templates-card--lime .templates-card__preview {
  background:
    linear-gradient(135deg, rgba(147, 198, 108, 0.2), transparent 60%),
    var(--color-bg-input);
}

.templates-card__preview-grid {
  position: absolute;
  inset: 18px;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  grid-template-rows: repeat(2, 1fr);
  gap: 8px;
  opacity: 0.46;
}

.templates-card__preview-grid span {
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: color-mix(in srgb, var(--color-bg-canvas-surface) 72%, transparent);
}

.templates-card__preview-icon {
  position: absolute;
  left: 20px;
  bottom: 18px;
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  color: var(--color-accent-base);
}

.templates-card--blue .templates-card__preview-icon {
  color: #6f9ee8;
}

.templates-card--green .templates-card__preview-icon {
  color: #5fbf92;
}

.templates-card--teal .templates-card__preview-icon {
  color: #45b8c4;
}

.templates-card--yellow .templates-card__preview-icon {
  color: #d6a84f;
}

.templates-card--red .templates-card__preview-icon {
  color: #e47575;
}

.templates-card--pink .templates-card__preview-icon {
  color: #de7fa6;
}

.templates-card--cyan .templates-card__preview-icon {
  color: #56b6de;
}

.templates-card--lime .templates-card__preview-icon {
  color: #93c66c;
}

.templates-card__badge {
  position: absolute;
  top: 12px;
  left: 12px;
  padding: 5px 8px;
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.templates-card__content {
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 16px;
}

.templates-card__title {
  font-size: 17px;
  font-weight: 600;
  line-height: 1.24;
  color: var(--color-text-primary);
}

.templates-card__desc {
  min-height: 58px;
  font-size: 13px;
  line-height: 1.5;
  color: var(--color-text-secondary);
}

.templates-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 6px;
  border-top: 1px solid var(--color-border-input);
  color: var(--color-text-secondary);
  font-size: 11px;
  font-weight: 600;
}

.templates-card__meta span + span::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 4px;
  margin: 0 8px 2px 0;
  border-radius: 999px;
  background: currentColor;
  opacity: 0.45;
}

.templates-empty {
  margin-top: 28px;
  padding: 42px 20px;
  text-align: center;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
}

.templates-empty h3 {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
}

.templates-empty p {
  margin: 0;
  font-size: 13px;
  color: var(--color-text-secondary);
}

@media (max-width: 980px) {
  .templates-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .templates-page {
    width: calc(100% - 28px);
    padding: 20px 0 48px;
  }

  .templates-grid {
    grid-template-columns: 1fr;
  }

  .templates-library__toolbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .templates-search {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/TemplatesPage.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,gCAAgC;EAChC,8EAA8E;AAChF;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;EACpB,0CAA0C;EAC1C,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB;;yBAEuB;EACvB,kDAAkD;AACpD;;AAEA;EACE;;yBAEuB;AACzB;;AAEA;EACE;;yBAEuB;AACzB;;AAEA;EACE;;yBAEuB;AACzB;;AAEA;EACE;;yBAEuB;AACzB;;AAEA;EACE;;yBAEuB;AACzB;;AAEA;EACE;;yBAEuB;AACzB;;AAEA;EACE;;yBAEuB;AACzB;;AAEA;EACE;;yBAEuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,+EAA+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,+CAA+C;EAC/C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".templates-page {\n  width: min(1180px, calc(100% - 48px));\n  margin: 0 auto;\n  padding: 32px 0 64px;\n  box-sizing: border-box;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n}\n\n.templates-search {\n  width: min(360px, 100%);\n  height: 46px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 14px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  color: var(--color-text-secondary);\n}\n\n.templates-search-row {\n  margin-top: 18px;\n}\n\n.templates-search:focus-within {\n  border-color: var(--color-text-secondary);\n}\n\n.templates-search input {\n  width: 100%;\n  min-width: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 14px;\n}\n\n.templates-search input::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.templates-card {\n  appearance: none;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n}\n\n.templates-card:hover {\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-text-secondary);\n  transform: translateY(-1px);\n}\n\n.templates-library__toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.templates-library__title {\n  margin: 0;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 28px;\n  font-weight: 400;\n  line-height: 1.15;\n}\n\n.templates-library__count {\n  margin: 6px 0 0;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.templates-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding-bottom: 18px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.templates-tab {\n  height: 32px;\n  padding: 0 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 999px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.templates-tab:hover {\n  color: var(--color-text-primary);\n}\n\n.templates-tab--active {\n  background: var(--color-text-primary);\n  border-color: var(--color-text-primary);\n  color: var(--color-bg-root);\n}\n\n.templates-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 22px;\n  margin-top: 28px;\n}\n\n.templates-card {\n  min-width: 0;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.templates-card__preview {\n  position: relative;\n  display: block;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  background:\n    linear-gradient(135deg, color-mix(in srgb, var(--color-accent-base) 20%, transparent), transparent 60%),\n    var(--color-bg-input);\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.templates-card--blue .templates-card__preview {\n  background:\n    linear-gradient(135deg, rgba(111, 158, 232, 0.24), transparent 60%),\n    var(--color-bg-input);\n}\n\n.templates-card--green .templates-card__preview {\n  background:\n    linear-gradient(135deg, rgba(95, 191, 146, 0.22), transparent 60%),\n    var(--color-bg-input);\n}\n\n.templates-card--teal .templates-card__preview {\n  background:\n    linear-gradient(135deg, rgba(69, 184, 196, 0.2), transparent 60%),\n    var(--color-bg-input);\n}\n\n.templates-card--yellow .templates-card__preview {\n  background:\n    linear-gradient(135deg, rgba(214, 168, 79, 0.22), transparent 60%),\n    var(--color-bg-input);\n}\n\n.templates-card--red .templates-card__preview {\n  background:\n    linear-gradient(135deg, rgba(228, 117, 117, 0.2), transparent 60%),\n    var(--color-bg-input);\n}\n\n.templates-card--pink .templates-card__preview {\n  background:\n    linear-gradient(135deg, rgba(222, 127, 166, 0.2), transparent 60%),\n    var(--color-bg-input);\n}\n\n.templates-card--cyan .templates-card__preview {\n  background:\n    linear-gradient(135deg, rgba(86, 182, 222, 0.2), transparent 60%),\n    var(--color-bg-input);\n}\n\n.templates-card--lime .templates-card__preview {\n  background:\n    linear-gradient(135deg, rgba(147, 198, 108, 0.2), transparent 60%),\n    var(--color-bg-input);\n}\n\n.templates-card__preview-grid {\n  position: absolute;\n  inset: 18px;\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  grid-template-rows: repeat(2, 1fr);\n  gap: 8px;\n  opacity: 0.46;\n}\n\n.templates-card__preview-grid span {\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: color-mix(in srgb, var(--color-bg-canvas-surface) 72%, transparent);\n}\n\n.templates-card__preview-icon {\n  position: absolute;\n  left: 20px;\n  bottom: 18px;\n  width: 48px;\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-accent-base);\n}\n\n.templates-card--blue .templates-card__preview-icon {\n  color: #6f9ee8;\n}\n\n.templates-card--green .templates-card__preview-icon {\n  color: #5fbf92;\n}\n\n.templates-card--teal .templates-card__preview-icon {\n  color: #45b8c4;\n}\n\n.templates-card--yellow .templates-card__preview-icon {\n  color: #d6a84f;\n}\n\n.templates-card--red .templates-card__preview-icon {\n  color: #e47575;\n}\n\n.templates-card--pink .templates-card__preview-icon {\n  color: #de7fa6;\n}\n\n.templates-card--cyan .templates-card__preview-icon {\n  color: #56b6de;\n}\n\n.templates-card--lime .templates-card__preview-icon {\n  color: #93c66c;\n}\n\n.templates-card__badge {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  padding: 5px 8px;\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.templates-card__content {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  padding: 16px;\n}\n\n.templates-card__title {\n  font-size: 17px;\n  font-weight: 600;\n  line-height: 1.24;\n  color: var(--color-text-primary);\n}\n\n.templates-card__desc {\n  min-height: 58px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n}\n\n.templates-card__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding-top: 6px;\n  border-top: 1px solid var(--color-border-input);\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.templates-card__meta span + span::before {\n  content: \"\";\n  display: inline-block;\n  width: 4px;\n  height: 4px;\n  margin: 0 8px 2px 0;\n  border-radius: 999px;\n  background: currentColor;\n  opacity: 0.45;\n}\n\n.templates-empty {\n  margin-top: 28px;\n  padding: 42px 20px;\n  text-align: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n}\n\n.templates-empty h3 {\n  margin: 0 0 8px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.templates-empty p {\n  margin: 0;\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n\n@media (max-width: 980px) {\n  .templates-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 720px) {\n  .templates-page {\n    width: calc(100% - 28px);\n    padding: 20px 0 48px;\n  }\n\n  .templates-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .templates-library__toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .templates-search {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
